// extracted by mini-css-extract-plugin
export var root = "_zu-0";
export var scroll = "_zu-1";
export var thumb = "_zu-3";
export var track = "_zu-2";